<!--
SPDX-FileCopyrightText: 2023 Marlon W (Mawoka)

SPDX-License-Identifier: MPL-2.0
-->

<script lang="ts">
	interface Props {
		disabled?: boolean;
		flex?: boolean;
		href?: undefined | string;
		target?: undefined | string;
		type?: 'button' | 'submit' | 'reset';
		children?: import('svelte').Snippet;
		onclick?: (event: MouseEvent) => void;
	}

	let {
		disabled = false,
		flex = false,
		href = undefined,
		target = '_self',
		type = 'button',
		children,
		onclick
	}: Props = $props();
</script>

{#if href}
	<a
		{href}
		{target}
		{disabled}
		class:opacity-50={disabled}
		class:cursor-not-allowed={disabled}
		class:pointer-events-none={disabled}
		class="text-white font-medium w-full px-5 py-2.5 leading-5 transition-all duration-200 ease-out transform bg-[var(--color-quiz-blue)] rounded-2xl shadow-md hover:shadow-lg hover:-translate-y-px active:translate-y-0 active:scale-[0.98] text-center outline-hidden hover:cursor-pointer"
		{onclick}
		class:flex
		class:justify-center={flex}
	>
		{@render children?.()}
	</a>
{:else}
	<button
		{disabled}
		{type}
		class="text-white font-medium hover:cursor-pointer w-full px-5 py-2.5 leading-5 transition-all duration-200 ease-out transform bg-[var(--color-quiz-blue)] rounded-2xl shadow-md hover:shadow-lg hover:-translate-y-px active:translate-y-0 active:scale-[0.98] text-center focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0 disabled:hover:shadow-md outline-hidden"
		{onclick}
		class:flex
		class:justify-center={flex}
	>
		{@render children?.()}
	</button>
{/if}
